var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PeerFileChannelClosedMessage, PeerFileErrorMessage, PeerFileMessage, PeerFileChannelOpenedMessage, RequestPeerFileDataMessage, RequestPeerFileInfoMessage, ResponsePeerFileInfoMessage, PeerFileClosedMessage } from "../../../messages/file/FileMessages";
import { busService } from "../../bus";
import { PeerLocalFile } from "./PeerLocalFile";
import { PeerRemoteFile } from "./PeerRemoteFile";
import { peerService } from "./PeerService";
import { PeerRemovedMessage } from "../../../messages/session/PeerMessages";
import { fileService } from "../../../modules/files";
const SHARED_URI_PREFIX = "shareId:";
class PeerFileSystemService {
    constructor() {
        this.connection = busService.connection("PeerFileSystemService");
        this.files = new Map();
        this.remoteFiles = new Map();
        this.handlePeerFileClosed = (file) => {
            this.removeLocalFile(file);
        };
        this.handlePeerFileMessage = (msg) => {
            const peerFile = this.remoteFiles.get(`${msg.fileId}`);
            if (!peerFile) {
                return;
            }
            let info = peerFile.clientsData.get(msg.clientId);
            if (!info) {
                info = {
                    filename: "",
                    data: msg.data
                };
                peerFile.clientsData.set(msg.clientId, info);
            }
            else {
                info.data = msg.data;
            }
            peerFile.handleLoaded(msg.clientId, info, msg.owner, msg.creator);
        };
        this.handlePeerFileClosedMessage = (msg, meta) => {
            if (meta.clientId !== undefined) {
                this.removeRemoteFileByFileId(msg.fileId, meta.clientId);
                return;
            }
            this.removeLocalFileByFileId(msg.fileId);
        };
        this.handlePeerFileChannelOpenedMessage = (msg) => {
            let peerFile = this.remoteFiles.get(`${msg.fileId}`);
            if (!peerFile) {
                peerFile = new PeerRemoteFile(`${msg.fileId}`);
                this.remoteFiles.set(`${msg.fileId}`, peerFile);
            }
            let fileInfo = peerFile.clientsData.get(msg.clientId);
            if (!fileInfo) {
                fileInfo = {
                    filename: msg.filename
                };
                peerFile.clientsData.set(msg.clientId, fileInfo);
            }
            else {
                fileInfo.filename = msg.filename;
            }
            peerFile.isLaoding = true;
            peerFile.isOpened = true;
        };
        this.handlePeerFileChannelClosedMessage = (msg) => {
            const peerFile = this.remoteFiles.get(`${msg.fileId}`);
            if (!peerFile) {
                return;
            }
            peerFile.isClosed = true;
            // ToDO hold open data channel and removed by closed?
            // this.remoteFiles.delete(`${msg.fileId}`);
        };
        this.handlePeerFileErrorMessage = (msg) => {
            const peerFile = this.remoteFiles.get(`${msg.fileId}`);
            if (!peerFile) {
                return;
            }
            peerFile.handleError(msg.clientId, msg.error);
        };
        this.handlePeerRemovedMessage = (msg) => {
            for (const info of this.remoteFiles.values()) {
                if (info.owner !== msg.clientId)
                    continue;
                this.removeRemoteFileByFileId(info.fileId, msg.clientId);
            }
        };
        this.handleRequestPeerFileInfoMessage = (msg, meta) => {
            if (!peerService.peerMgr)
                return;
            if (meta.clientId === undefined) {
                console.error(`[multiplayer] Got request for file info ${msg.fileId} without clientId`);
                return;
            }
            const localInfo = this.files.get(msg.fileId);
            let owner;
            if (localInfo) {
                owner = localInfo.owner;
            }
            else {
                const remoteInfo = this.remoteFiles.get(msg.fileId);
                if (remoteInfo) {
                    owner = remoteInfo.owner;
                }
            }
            peerService.peerMgr.sendToBusMessage(meta.clientId, new ResponsePeerFileInfoMessage(msg.fileId, owner));
        };
        this.handleResponsePeerFileInfoMessage = (msg) => {
            if (!peerService.peerMgr) {
                const errorMsg = new PeerFileErrorMessage("", msg.fileId, "System error");
                this.handlePeerFileErrorMessage(errorMsg);
                this.connection.send(errorMsg);
                return;
            }
            if (msg.ownerClientId === undefined) {
                const errorMsg = new PeerFileErrorMessage("", msg.fileId, "No host found");
                this.handlePeerFileErrorMessage(errorMsg);
                this.connection.send(errorMsg);
                return;
            }
            const info = this.remoteFiles.get(msg.fileId);
            if (!info)
                return;
            peerService.peerMgr.sendToBusMessage(msg.ownerClientId, new RequestPeerFileDataMessage(msg.fileId));
        };
        this.handleRequestPeerFileDataMessage = (msg, meta) => __awaiter(this, void 0, void 0, function* () {
            if (!peerService.peerMgr)
                return;
            if (meta.clientId === undefined) {
                console.error(`[multiplayer] Got request for file ${msg.fileId} without clientId`);
                return;
            }
            const file = this.files.get(msg.fileId);
            if (!file) {
                console.error(`[multiplayer] Can't find file ${msg.fileId} for request`);
                peerService.peerMgr.sendToBusMessage(meta.clientId, new PeerFileErrorMessage(peerService.clientId, msg.fileId, "Cant't find file"));
                return;
            }
            try {
                yield file.sendTo(meta.clientId);
            }
            catch (error) {
                peerService.peerMgr.sendToBusMessage(meta.clientId, new PeerFileErrorMessage(peerService.clientId, msg.fileId, "Cant't send file"));
                console.error("[multiplayer] error", error);
            }
        });
        this.connection.subscribeByType(PeerFileMessage, this.handlePeerFileMessage);
        this.connection.subscribeByType(PeerFileClosedMessage, this.handlePeerFileClosedMessage);
        this.connection.subscribeByType(PeerFileChannelOpenedMessage, this.handlePeerFileChannelOpenedMessage);
        this.connection.subscribeByType(PeerFileChannelClosedMessage, this.handlePeerFileChannelClosedMessage);
        this.connection.subscribeByType(PeerFileErrorMessage, this.handlePeerFileErrorMessage);
        this.connection.subscribeByType(PeerRemovedMessage, this.handlePeerRemovedMessage);
        this.connection.subscribeByType(RequestPeerFileInfoMessage, this.handleRequestPeerFileInfoMessage);
        this.connection.subscribeByType(ResponsePeerFileInfoMessage, this.handleResponsePeerFileInfoMessage);
        this.connection.subscribeByType(RequestPeerFileDataMessage, this.handleRequestPeerFileDataMessage);
    }
    checkShareUri(uri) {
        if (!uri.startsWith(SHARED_URI_PREFIX))
            return undefined;
        return uri.substring(SHARED_URI_PREFIX.length);
    }
    createShareUri(fileId) {
        return `${SHARED_URI_PREFIX}${fileId}`;
    }
    createPeerFile(fileId) {
        fileId = fileId !== undefined ? fileId : fileService.generateUUIDFileId();
        const peerFile = new PeerLocalFile(fileId, peerService.clientId, peerService.clientId);
        peerFile.onClosed.add(this.handlePeerFileClosed);
        this.files.set(fileId, peerFile);
        return peerFile;
    }
    removeLocalFile(file) {
        file.onClosed.remove(this.handlePeerFileClosed);
        this.files.delete(file.fileId);
        fileService.remove(file);
    }
    removeLocalFileByFileId(fileId) {
        const file = this.files.get(fileId);
        if (!file)
            return;
        this.removeLocalFile(file);
    }
    removeRemoteFile(file, clientId) {
        if (clientId !== undefined) {
            file.handleUnload(clientId);
        }
        this.remoteFiles.delete(file.fileId);
        fileService.remove(file);
    }
    removeRemoteFileByFileId(fileId, clientId) {
        const file = this.remoteFiles.get(fileId);
        if (!file)
            return false;
        this.removeRemoteFile(file, clientId);
        return true;
    }
    getFile(fileId) {
        const localFile = this.files.get(fileId);
        if (localFile)
            return localFile;
        return this.remoteFiles.get(fileId);
    }
    subscribePeerRemoteFile(fileId) {
        let isCreated = false;
        let peerFile = this.remoteFiles.get(fileId);
        if (!peerFile) {
            isCreated = true;
            peerFile = new PeerRemoteFile(fileId);
            this.remoteFiles.set(fileId, peerFile);
        }
        const localFile = this.files.get(fileId);
        if (localFile && localFile.data) {
            const clientId = peerService.clientId;
            let info = peerFile.clientsData.get(clientId);
            if (!info) {
                info = {
                    filename: "",
                    data: localFile.data
                };
                peerFile.creator = clientId;
                peerFile.clientsData.set(clientId, info);
            }
            else {
                info.data = localFile.data;
            }
            peerFile.handleLoaded(clientId, info, clientId, clientId);
        }
        else if (isCreated) {
            if (peerService.peerMgr && peerService.hostClientId !== "" && peerService.hostClientId !== peerService.clientId) {
                peerService.peerMgr.sendToBusMessage(peerService.hostClientId, new RequestPeerFileInfoMessage(fileId));
            }
            else {
                const errorMsg = new PeerFileErrorMessage(peerService.clientId, fileId, `Can't find file ${fileId}`);
                this.handlePeerFileErrorMessage(errorMsg);
                this.connection.send(errorMsg);
            }
        }
        return peerFile;
    }
}
export const peerFileSystemService = new PeerFileSystemService();
